<template>
  <div>
    <CrudList
      title="Notificaciones de pedidos de request"
      storeName="Notifications_request_cms"
      :canAdd="false"
      :canEdit="false"
      :canDelete="true"
      :canShow="true"
      next-link="/admin/push_notifications"
      :breadcrumbs="[
        {
          text: 'Marketing y comunicación',
          disabled: false,
          href: '/admin/notifications_request_cms'
        },
        {
          text: 'Notificaciones de pedidos de request',
          disabled: false,
          href: '#'
        }
      ]"
    >
      <template v-slot:user="{ item }">
        <p>
          {{
            item.user_id && item.user_id
              ? `${item.user_id.name || ""} ${item.user_id.last_name || ""}`
              : ""
          }}
        </p>
      </template>

      <template v-slot:description="{ item }">
        <v-container
          id="scroll-target"
          style="max-height: 210px"
          class="overflow-y-auto"
        >
          <v-row v-scroll:#scroll-target="onScroll">
            <p>{{ item.description }}</p>
          </v-row>
        </v-container>
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
  data: () => ({
    offsetTop: 0,
  }),
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
  },
};
</script>
